import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import multi from "redux-multi";
import promise from "redux-promise";
import reducers from "./index";

const enhancers = [];
const isDevelopment = process.env.NODE_ENV === "development";

if (
  isDevelopment &&
  typeof window !== "undefined" &&
  window.devToolsExtension
) {
  enhancers.push(window.devToolsExtension());
}

const createStoreWithMiddleware = applyMiddleware(
  thunk,
  multi,
  promise
)(createStore);
const store = createStoreWithMiddleware(reducers);

export default store;
